import { useState, useEffect } from "react";
import { createUseStyles } from "react-jss";

import { cardSetTypeService } from "services";
import { CardSetTypeCommon, CardSetTypeDto, CardSetTypeRequestDto } from "dtos/shard/card-set-type.dto";
import { UserDto } from "dtos/user.dto";

import widgets from "styles/widgets";
import { useResources } from "hooks/resources.hook";
import { useEditorActions } from "hooks/editor-actions.hook";
import { useEditorPreview } from "hooks/editor-preview.hook";
import EditorControls from "../editor-controls";

const styles = createUseStyles({
    container: {
        width: "100%",
    },
});

export default function CardSetTypeEditor(props: {
    user?: UserDto, // Optional dto of the user.
    cardSetType?: Partial<CardSetTypeDto>,
    preview?: Partial<CardSetTypeDto>,
    onPreviewUpdate?: (previewDto: Partial<CardSetTypeDto>) => void,
    onClose?: () => void,
    onSave?:(cardSetType: CardSetTypeDto) => void,
}): JSX.Element
{
    // Dtos:
    const freshCommon: CardSetTypeCommon = {
        name: props.cardSetType?.name ?? "",
    };
    const freshRequestDto: CardSetTypeRequestDto = {
        id: props.cardSetType?.id,
        ...freshCommon,
    };
    const freshPreviewDto: Partial<CardSetTypeDto> = props.preview ? structuredClone(props.preview) : props.cardSetType ? structuredClone(props.cardSetType) : {
        id: undefined,
        ...freshCommon,
    };

    // Hooks:
    const resources = useResources(props.user);
    const [previewDto, requestDto, previewUpdate, setRequestDto] = useEditorPreview(freshPreviewDto, freshRequestDto, props.onPreviewUpdate);
    const [onTextChange, onNumberChange, onRteChange, onCheckboxChange, onPopup] = useEditorActions(props.user, "cardSetType", resources, requestDto, previewDto, setRequestDto, props.onPreviewUpdate);

    // Effects:
    useEffect(() => {
        setRequestDto(freshRequestDto);
    }, [props.cardSetType]);

    // Styles:
    const widgetClasses = widgets();
    const classes = styles();

    // CardSetTypes:
    const reset = () => {
        setRequestDto(freshRequestDto);
        if (props.onPreviewUpdate) {
            props.onPreviewUpdate(props.cardSetType ?? previewDto);
        }
    };
    
    // Return Component:
    return (
        <div className={`${widgetClasses.form} ${classes.container}`}>
            <div className={`${widgetClasses.row}`}>
                <label>Name</label>
                <input id="name" type="text" value={requestDto.name ?? ""} onChange={onTextChange} />
            </div>

            <hr/>
            <EditorControls
                editorName="cardSetType"
                service={cardSetTypeService}
                subject={props.cardSetType}
                subjectName={props.cardSetType?.name ?? ""}
                requestDto={requestDto}
                onSave={props.onSave}
                onReset={reset}
                onClose={props.onClose}
            />
            <hr/>
        </div>
    );
}